import { render, staticRenderFns } from "./MapMarker.vue?vue&type=template&id=35854f70&"
import script from "./MapMarker.vue?vue&type=script&lang=js&"
export * from "./MapMarker.vue?vue&type=script&lang=js&"
import style0 from "./MapMarker.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports